import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = no, object = yes
  const token = localStorage.getItem("immersion_admin_token");

  useEffect(() => {
    if (!token) {
      setAdmin(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem("immersion_admin_token");
        sessionStorage.setItem("immersion_session_expired", "1");
        setAdmin(false);
      });
  }, [token]);

  const login = (data) => {
    localStorage.setItem("immersion_admin_token", data.token);
    setAdmin({ email: data.email, role: data.role });
  };

  const logout = () => {
    localStorage.removeItem("immersion_admin_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
